import middlewareConfig from "./middleware-config";
import { MIDDLEWARE_ENUMS } from "./middleware-constants";

const newSellerVasCmsService = (api) => {

    const getCmsTemplateData = (template) => {
        return api.get(`/api/v1/bff-schema/page/page-template/${template}`);
    };

    return {
        getCmsTemplateData
    };
};

export const NewSellerVasCmsService = newSellerVasCmsService(middlewareConfig(MIDDLEWARE_ENUMS.NEW_SELLER_VAS_CMS_SERVICE));
